import { Injectable } from '@angular/core';
import { ApiRequestService } from './api-request.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { FileModel } from './file.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly resourceUrl = 'v1/files';

  constructor(private api: ApiRequestService) {}

  private createFromForm(file: File) {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.api
      .makeRequestObservable('post', 'v1/files/form', form)
      .toPromise();
  }

  public async createManyFromForm(files: FileList) {
    if (!files || !files.length) { return []; }
    const requests = [];
    for(let i = 0; i < files.length; i++) {
      requests.push(this.createFromForm(files[i]));
    }
    const responses = await Promise.all(requests);
    const createdFiles = responses.map(response => response.data);
    return createdFiles;
  }

  // findAll() was removed along with the GET v1/files endpoint it called. That endpoint returned
  // every file row in the database with no account scoping (SC-2788) and had no caller here.

  // findAllForHazard() and findAllForHazardousSubstance() were removed along with the
  // GET v1/files/hazards/{id} and GET v1/files/hazardous-substances/{id} endpoints they called.
  // Neither endpoint scoped the parent record to the caller's account (SC-2788). The hazard files
  // are already returned, correctly authorised, by GET v1/hazards/{id}; the hazardous substance
  // equivalent had no caller at all.

  public remove(id: number): Observable<{}> {
    return this.api.makeRequestObservable('delete', `${this.resourceUrl}/${id}`);
  }
}
